// Libraries
import axios from 'axios';
const api = process.env.REACT_APP_SERVER_ENDPOINT;

// PROFILE SERVICES
export default {
	/**
	 * Update user phone number.
	 *
	 * URL: /profile/ {msisdn}
	 * Method: PUT
	 * URL Params: Required: none
	 * Optional: msisdn = [string]
	 * User MSISDN, e.g.: +351999999999
	 * Success Response: 200
	 * Error Response: 401 Unauthorized - list of authentication servers
	 *
	 * @param {*} msisdn
	 * @returns
	 */
	updateUserMsisdn(msisdn) {
		return axios.put(`${api}/profile/${msisdn}`, null, {
			withCredentials: true,
		});
	},
	/**
	 * Update user email.
	 *
	 * URL: /profile/contact_email/ {email}
	 * Method: PUT
	 * Success Response: 200
	 * Error Response: 401 Unauthorized - list of authentication servers
	 *
	 * @param {*} msisdn
	 * @returns
	 */
	updateUserEmail(email) {
		return axios.put(`${api}/profile/contact_email/${email}`, null, {
			withCredentials: true,
		});
	},
	/**
	 *   Retrieve my list of invitation codes and its status
	 *
	 * URL: /invitation/my
	 * Method: GET
	 * URL Params:
	 * - Required: none
	 * - Optional : none
	 * Success Response: 200
	 * Error Response : 401 Unauthorized
	 *
	 * @param {*} msisdn
	 * @returns
	 */
	getInvitationCodes() {
		return axios.get(`${api}/invitation/my`, {
			withCredentials: true,
		});
	},

	/**
	 *  Retrieve my team info
	 *
	 * URL: /team/my
	 * Method: GET
	 * URL Params:
	 * - Required: none
	 * - Optional : none
	 * Success Response: 200
	 * Error Response : 401 Unauthorized
	 *
	 * @param {*} msisdn
	 * @returns
	 */
	getMyTeam() {
		return axios.get(`${api}/team/my`, {
			withCredentials: true,
		});
	},

	/**
	 *  Retrieves a specific team details
	 *
	 * URL: /${teamId}/${challengeId}
	 * Method: GET
	 * URL Params:
	 * - Required: none
	 * - Optional : none
	 * Success Response: 200
	 * Error Response : 401 Unauthorized
	 *
	 * @param {*} msisdn
	 * @returns
	 */
	getTeamDetails(teamId, challengeId) {
		return axios.get(`${api}/team/${teamId}/${challengeId}`, {
			withCredentials: true,
		});
	},

	/**
	 * @description Updates My Team name
	 * @url /{teamId}/{teamName}
	 * @method PUT
	 * @since 2018-07-16
	 * @param {*} teamid
	 * @param {*} teamname
	 * @returns
	 */
	updateMyTeamsName(teamid, teamname) {
		return axios.put(`${api}/team/${teamid}/${teamname}`, null, {
			withCredentials: true,
		});
	},

	/**
	 * @description Deletes the current user from the users database
	 * @date 2018-07-16
	 * @returns
	 */
	deleteUserAccount() {
		return axios.delete(`${api}/auth/delete`, {
			withCredentials: true,
		});
	},

	/**
	 * @description Transfers the user to another team, by passing its transfer code as a parameter.
	 * @date 2018-07-16
	 * @param {*} transferCode
	 * @returns
	 */
	transferUserToAnotherTeam(transferCode) {
		return axios.put(`${api}/team/change/${transferCode}`, null, {
			withCredentials: true,
		});
	},
};



// WEBPACK FOOTER //
// ./src/data/services/profiles-services.js